import { useSelector } from 'react-redux'
import { selectFilter, filterList } from '../../app/store/mygames/mygames.state'
import { useAppDispatch } from '../../app/store/store'
import {
  FilterWrapper,
  FilterContainer,
  SelectorUnderlay,
  Selector,
} from './filter.style'

export const Filter = () => {
  const dispatch = useAppDispatch()
  const filter = useSelector(selectFilter)

  return (
    <FilterWrapper>
      <FilterContainer>
        <SelectorUnderlay filter={filter} data-testid="selUnderlay" />
        <Selector
          onClick={() => dispatch(filterList('won'))}
          selected={filter === 'won'}
        >
          Won
        </Selector>
        <Selector
          onClick={() => dispatch(filterList('lost'))}
          selected={filter === 'lost'}
        >
          Lost
        </Selector>
        <Selector
          onClick={() => dispatch(filterList('all'))}
          selected={filter === 'all'}
        >
          All
        </Selector>
      </FilterContainer>
    </FilterWrapper>
  )
}
